<script setup>
import AgentLayout from "@/views/layouts/AgentLayout.vue";
import EngagementBoard from "@/components/analytics/EngagementBoard.vue";
</script>

<template>
  <AgentLayout full-width>
    <EngagementBoard />
  </AgentLayout>
</template>
